import { AccountPaymentMethod, PaymentAccount } from '../models';

export const getAccountDisplayName = (account?: PaymentAccount): string => {
  let displayName = account?.displayName;

  if (
    account?.paymentMethod === AccountPaymentMethod.Ach &&
    account?.accountLast4 &&
    displayName === `ACH - ${account?.accountLast4.slice(-4)}`
  ) {
    displayName = displayName.replace('ACH - ', 'BANK - ');
  }

  return displayName;
};
